const init = () => {
	for (const f of document.querySelectorAll('[data-filter-select]')) {
		f.addEventListener('change', (e) => {
			const v = e.target.value;

			if (v !== '') {
				window.location = v;
			}
		});
	}
}

export default init